import { ArrowDropDown } from '@mui/icons-material'
import { Box, InputAdornment, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import { ArrowDropDownIcon, DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { DateRangePicker, MultiInputDateRangeField } from '@mui/x-date-pickers-pro'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import dayjs, { Dayjs } from 'dayjs'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { ApiStarRatingComparision } from '../../apiService/Core/Apicall'
import Domains from '../../global/constants/domain'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../global/config/store'
import { setSelectedMonth } from '../../global/config/Reducer/MonthSlice'
import storage from '../../utils/storage'

const getIconColorByDomain = () => {
    const domain = window.location.hostname;

    if (domain.includes(Domains.ALDI)) return '#001F79';
    if (domain.includes(Domains.BLOOMS)) return '#1C2B90';
    if (domain.includes(Domains.MM)) return '#ADB792';

    return '#ADB792';
};
const primary_color = getIconColorByDomain()


const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: primary_color,
        color: theme.palette.common.white,
        padding: "10px 20px"
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        padding: " 10px 20px",
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(even)': {
        backgroundColor: `${primary_color}1A`,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));


function RankingReport() {
    const selectedMonth = useSelector((state: RootState) => state.month.selectedMonth)
    const dispatch = useDispatch()
    const [startMonth, setStartMonth] = React.useState<any>(dayjs(selectedMonth).startOf('year'));
    const [endMonth, setEndMonth] = React.useState<any>(dayjs(selectedMonth).startOf('month'));
    const [comparisionreport, setcomparisionReport] = React.useState<any>([]);
    const clientEntity = useSelector((state: RootState) => state.clientEntity.selectedEntity)




    useEffect(() => {
        const getData = async () => {
            const data = `?s_year=${startMonth.year()}&s_month=${startMonth.month() + 1}&clientEntityId=${storage.getItem('clientEntityId')}&isClientEntityIdRequired=true&e_year=${endMonth.year()}&e_month=${endMonth?.month() + 1}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`
            try {
                const response = await ApiStarRatingComparision(data)
                setcomparisionReport(response.data)

            } catch (error: any) {
                // toast.error(error)
            }

        }
        getData()
    }, [startMonth, endMonth, clientEntity])

    useEffect(() => {
        setEndMonth(dayjs(selectedMonth).startOf('month'))
    }, [selectedMonth])

    return (
        <Box className='mt-3'>
            <Box className='d-flex justify-content-end'>
                <Box justifyContent={{ xs: 'start', md: 'end' }} className='col-md-4 col-12  d-flex align-itmes-center'>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Box display="flex" width='100%' gap={2}>
                            <DatePicker value={startMonth} className='col'
                                label="Start Month:"
                                views={['month', 'year']}
                                format="MMM-YY"
                                maxDate={endMonth}
                                onChange={(e) => { setStartMonth(e); }}
                                slots={{
                                    openPickerIcon: ArrowDropDownIcon,
                                }}
                            />
                            <DatePicker value={endMonth} className='col'
                                label="End Month:"
                                views={['month', 'year']}
                                format="MMM-YY"
                                minDate={startMonth}
                                onChange={(e: any) => {
                                    const isoString = e?.startOf('month').toISOString();
                                    dispatch(setSelectedMonth(isoString));
                                }} slots={{
                                    openPickerIcon: ArrowDropDownIcon,
                                }}
                            />
                        </Box>
                    </LocalizationProvider>
                </Box>
            </Box>

            <Box>
                <Box>
                </Box>
                {/* ----------------------------------------------------- Group Report ----------------------------- */}
                <Box className='table'>
                    <Typography className='fw-bold my-2' variant='h6'>Group Comparision Report</Typography>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 700 }} aria-label="customized table">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell align='center'>Rank</StyledTableCell>
                                    <StyledTableCell>Group Name</StyledTableCell>
                                    <StyledTableCell align='center'>Report Count</StyledTableCell>
                                    <StyledTableCell align='center'>Rating</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <StyledTableRow>
                                    <StyledTableCell align='center'>{comparisionreport?.groupComparisonReport?.rank ?? 'N/A'}</StyledTableCell>
                                    <StyledTableCell>{storage.getItem('clientEntityName')}</StyledTableCell>
                                    <StyledTableCell align='center'>{comparisionreport?.groupComparisonReport?.reportCount ?? 'N/A'}</StyledTableCell>
                                    <StyledTableCell align='center'>{comparisionreport?.groupComparisonReport?.rating ?? 'N/A'}</StyledTableCell>

                                </StyledTableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>

                {/* ----------------------------------------------------- Venue Comparision Report ----------------------------- */}
                <Box className='table mt-5'>
                    <Typography className='fw-bold my-2' variant='h6'>Venue Comparision Report</Typography>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 700 }} aria-label="customized table">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell align='center'>Rank</StyledTableCell>
                                    <StyledTableCell>Venue Name</StyledTableCell>
                                    <StyledTableCell align='center'>Report Count</StyledTableCell>
                                    <StyledTableCell align='center'>Rating</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {((comparisionreport?.venueComparisonReport)?.length > 0) ? comparisionreport?.venueComparisonReport?.map((item: any, index: number) => (
                                    <StyledTableRow>
                                        <StyledTableCell align='center'>{item?.rank ?? 'N/A'}</StyledTableCell>
                                        <StyledTableCell>{item?.venueName ?? "-"}</StyledTableCell>
                                        <StyledTableCell align='center'>{item?.reportCount ?? 'N/A'}</StyledTableCell>
                                        <StyledTableCell align='center'>{item?.avgStarRating ?? 'N/A'}</StyledTableCell>
                                    </StyledTableRow>

                                )) : <StyledTableCell align='center' colSpan={4} ><Typography className='mx-auto text-center' variant='h5'>No Data Found</Typography></StyledTableCell>}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>

                {/* ------------------------------------------------- Cateory Report --------------------------------------------- */}

                <Box className='mt-5'>
                    <Typography className='fw-bold my-2' variant='h6'> Category Report</Typography>
                    <Box className='d-flex align-items-start gap-1 flex-wrap'>
                        {((comparisionreport?.categoryReport)?.length) > 0 ? comparisionreport?.categoryReport?.map((item: any, index: any) => (
                            <Box className='table' sx={{ width: { xs: "100%", md: '33%' } }}>
                                <TableContainer component={Paper}>
                                    <Table aria-label="customized table">
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell colSpan={3} align='center'>{item?.categoryName}</StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <StyledTableRow>
                                                <StyledTableCell align='center' style={{ borderRight: '1px solid black' }} component="th">
                                                    {item?.rank}
                                                </StyledTableCell>
                                                <StyledTableCell style={{ borderRight: '1px solid black' }}>{storage.getItem('clientEntityName')}</StyledTableCell>
                                                <StyledTableCell align="center">{item?.averageScore}</StyledTableCell>
                                            </StyledTableRow>

                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>
                        )) : <Typography className='text-center w-100 my-3' variant='h5'>No Data Found</Typography>}

                    </Box>

                </Box>
            </Box>
        </Box>
    )
}

export default RankingReport
